var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPercentBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 193,
    viewBox: "0 0 370 193",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CEE69B",
    width: 370,
    height: 193,
    rx: 22
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237 86h100v100H237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.034 173.692c-8.095 0-14.658-6.562-14.658-14.658 0-8.095 6.563-14.658 14.658-14.658 8.096 0 14.658 6.563 14.658 14.658 0 8.096-6.562 14.658-14.658 14.658zm0-8.376a6.282 6.282 0 1 0 0-12.564 6.282 6.282 0 0 0 0 12.564zm-46.068-37.692a14.658 14.658 0 1 1 0-29.316c8.095 0 14.658 6.562 14.658 14.658 0 8.095-6.563 14.658-14.658 14.658zm0-8.376a6.282 6.282 0 1 0 0-12.564 6.282 6.282 0 0 0 0 12.564zm52.648-18.783 5.921 5.921-65.144 65.15-5.922-5.922 65.14-65.15h.005z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.5,
    x: 99,
    y: 174,
    width: 251,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 118 0)",
    x: 30,
    y: 174,
    width: 58,
    height: 5,
    rx: 2.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentBg);
export default __webpack_public_path__ + "static/media/percent-bg.c7d33c3c414949f7219fca31dafaf761.svg";
export { ForwardRef as ReactComponent };